import React from "react";
import Badge from "components/basic/badge";
import { DisplayStatus, MEETING_STATUS_META } from "../../types";

// Maps a meeting's display status to the shared Badge pill.
const StatusChip: React.FC<{ status: DisplayStatus }> = ({ status }) => {
  const meta = MEETING_STATUS_META[status];
  return <Badge label={meta.label} color={meta.color} />;
};

export default StatusChip;
